import { Component, Input, OnChanges, SimpleChanges } from '@angular/core';
import {
  faWallet,
  faMobileScreen,
  faBuildingColumns,
  faCreditCard,
  faMoneyBill,
  faChevronRight,
  faClock
} from '@fortawesome/free-solid-svg-icons';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { forkJoin } from 'rxjs';
import { CommonServiceService } from 'src/app/share/services/common-service/common-service.service';
import { DayBookService } from 'src/app/share/services/day-book/day-book.service';

@Component({
  selector: 'app-day-book-payments',
  templateUrl: './day-book-payments.component.html',
  styleUrls: ['./day-book-payments.component.scss'],
  standalone: false
})
export class DayBookPaymentsComponent implements OnChanges {
  protected readonly faWallet = faWallet;
  protected readonly faChevronRight = faChevronRight;
  protected readonly faClock = faClock;
  protected readonly faCreditCard = faCreditCard;

  @Input() selectedDate: any;
  @Input() selectedBranch: any;

  receivedToday = 0;
  unsettledBalance = 0;
  creditsAmount = 0

  paymentCategories = [
    {
      title: 'UPI',
      mode: 'UPI',
      icon: faMobileScreen,
      total: 0,
      details: [] as any[]
    },
    {
      title: 'Bank Transfer',
      mode: 'BankTransfer',
      icon: faBuildingColumns,
      total: 0,
      details: [] as any[]
    },
    {
      title: 'Cards',
      mode: 'Card',
      icon: faCreditCard,
      total: 0,
      details: [] as any[]
    },
    {
      title: 'Cash',
      mode: 'Cash',
      icon: faMoneyBill,
      total: 0,
      details: [] as any[]
    },
    {
      title: 'Bajaj Finance',
      mode: 'BajajFinance',
      icon: faCreditCard,
      total: 0,
      details: [] as any[]
    },
    {
      title: 'Credits',
      total:0,
      details: [] as any[]
    }
  ];

  loader: boolean = false;
  errMsg: string = '';

  constructor(
    private readonly dayBookService: DayBookService,
    private readonly modalService: NgbModal,
    private readonly cmnService: CommonServiceService,
  ) { }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['selectedDate'] || changes['selectedBranch']) {
      this.paymentCategories.forEach(cat => {
        cat.total = 0;
        cat.details = [];
      });
      this.getData();
    }
  }

  getParams() {
    const params: any = { created_date: this.selectedDate, };
    if (this.selectedBranch) params.company = this.selectedBranch;
    return params
  }

  getData() {
    this.loader = true;
    this.errMsg = '';
    const params = this.getParams();
    forkJoin({
      credits: this.dayBookService.getCreditsSummary(params),
      payments: this.dayBookService.getPayments({ ...params, expand: true })
    }).subscribe({
      next: (res: any) => {
        this.loader = false;
        this.mapResponse(res?.payments?.data || {});
        this.mapCredits(res?.credits?.data || []);
      },
      error: (err: any) => {
        this.loader = false;
        this.errMsg = 'Failed to fetch response';
      }
    });
  }

  mapResponse(data: any) {
    this.receivedToday = this.cmnService.parseNumberOrZero(data?.totalReceived);
    this.creditsAmount = this.cmnService.parseNumberOrZero(data?.creditAmount);
    (data.breakdown || []).forEach((item: any) => {
      const category = this.paymentCategories.find(c => c.mode === item.mode);
      if (category) {
        category.total = this.cmnService.parseNumberOrZero(item.totalAmount);
        category.details = (item.accounts || []).map((acc: any) => ({
          label: acc.name,
          location: acc.branch,
          amount: this.cmnService.parseNumberOrZero(acc.amount)
        }));
      }
    });
  }  

  mapCredits(data: any) {
    this.paymentCategories[5].details = data.map((item: any) => ({
      location: item.companyName,
      ...item
    }));
    this.paymentCategories[5].total = this.paymentCategories[5].details.reduce(
      (sum, item) => sum + (Number(item.amount) || 0),
      0
    );
  }

  viewAllPayments(modalContent: any) {
    this.modalService.open(modalContent, { size: 'lg', centered: true, scrollable: true });
  }
}
